import { IconWaves } from "@/assets/icons/geist/IconWaves";
import { Text } from "@/components/podkit/typography/Text";
import type { AgentMessageFragment, AgentMessageFragmentThinking } from "@/hooks/use-stream-conversation";

type ThinkingProps = {
    fragment: AgentMessageFragmentThinking;
    onClick?: (fragment: AgentMessageFragment) => void;
};

export const Thinking: React.FC<ThinkingProps> = ({ fragment, onClick }) => {
    if (!fragment.completed) {
        return (
            <div
                className="flex cursor-pointer items-center justify-start gap-1 hover:text-content-primary"
                onClick={() => onClick?.(fragment)}
            >
                <IconWaves className="size-6 text-content-orange" animating />
                <div className="flex">
                    <Text className="font-mono text-sm tracking-tight text-content-secondary">Thinking</Text>
                    <Text className="animate-pulse font-mono text-sm tracking-tight text-content-secondary">
                        &#8230;
                    </Text>
                </div>
            </div>
        );
    }

    return (
        <div
            className="cursor-pointer font-mono text-sm text-content-secondary hover:text-content-primary"
            onClick={() => onClick?.(fragment)}
        >
            Thoughts
        </div>
    );
};
